import { render, staticRenderFns } from "./PayuFail.vue?vue&type=template&id=84830236"
import script from "./PayuFail.vue?vue&type=script&lang=js"
export * from "./PayuFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports